import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Producto } from '../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductoAlertaService } from '../../_services/producto-alerta.service';
import { ProductoAlerta } from '../../_models/producto-alerta';
import { Alerta } from '../../_models/alerta';
import { AlertaService } from '../../_services/alerta.service';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-producto-alerta',
  templateUrl: 'producto-alerta.component.html'
} )

export class ProductoAlertaComponent implements OnInit, OnChanges {

  @Input() producto: Producto;
  @Input() visualizar:boolean;
  @Input() idProductoAlerta: string;
  @Output() actualizarProductoAlerta: EventEmitter<ProductoAlerta> = new EventEmitter<ProductoAlerta>();
  @Output() cancelar: EventEmitter<any> = new EventEmitter<any>();
  public carInformacionInicial:boolean = true;
  public procesando:boolean = false;
  public formProductoAlerta: FormGroup;
  public productoAlerta:ProductoAlerta;
  public alertaSubmitted:boolean = false;
  public listaAlertas:SelectItem[] = [];
  public tituloBoton:string;
  get f() {
    return this.formProductoAlerta.controls;
  }

  constructor(private fb:FormBuilder,
              private productoAlertaService:ProductoAlertaService,
              private confirmService:ConfirmationService,
              private navService:NavService,
              private alertaService:AlertaService){
  }

  ngOnInit(): void {
    this.setTituloBoton();
    this.getListas();
    this.loadAlerta();
    /*if ( this.idProductoAlerta ) {
      this.productoAlertaService.obtenerPorId(this.idProductoAlerta).subscribe( prodAlerta => {
        this.productoAlerta = prodAlerta;
        this.actualizarProductoAlerta.emit(prodAlerta);
      });
    }*/
  }

  ngOnChanges( changes: SimpleChanges ): void {
  }

  private loadAlerta(){
    if ( this.idProductoAlerta ){
      this.productoAlertaService.obtenerPorId(this.idProductoAlerta).subscribe( pAlerta => {
        this.productoAlerta = pAlerta;
        this.setFormData(pAlerta);
        this.carInformacionInicial = false;
        this.actualizarProductoAlerta.emit(pAlerta);
      }, e => {
        console.log(e);
        this.setFormData(null);
        this.carInformacionInicial = false;
      });
    } else {
      this.setFormData(null);
      this.carInformacionInicial = false;
    }
  }

  private setFormData(data?:ProductoAlerta){
    this.formProductoAlerta = this.fb.group( {
      idAlerta: [ data ? data.idAlerta : null, [Validators.required] ],
      noAplica: [ data ? data.indicadorNoAplica : null ],
      indicadorHabilitado: [ data ? data.indicadorHabilitado : null ],
    } );
  }

  private getListas(){
    forkJoin(
      this.alertaService.listadoHabilitados(),
      this.productoAlertaService.listadoPorIdProducto(this.producto.idProducto)
    ).subscribe( ([alertas, prodAlertas]) => {
      this.setItemsListaAlertas(prodAlertas, alertas);
    });
    /*this.alertaService.listadoHabilitados().subscribe( alertas => {
      alertas.forEach( a => {
        const item = { value:a.idAlerta, label:a.codigo };
        this.listaAlertas.push(item);
      });
    });*/
  }

  private setItemsListaAlertas(prodAlertas:ProductoAlerta[], alertas:any[]){
    alertas.map( a => {
      const exist = prodAlertas.find(x => x.idAlerta === a.idAlerta);
      if ( !exist ){
        const item = { value:a.idAlerta, label:a.codigo };
        this.listaAlertas.push(item);
      }
    });
  }

  private setTituloBoton(){
    if ( !this.idProductoAlerta ){
      this.tituloBoton = 'BTN_GUARDAR';
    } else {
      this.tituloBoton = 'BTN_ACTUALIZAR';
    }
  }

  public cancelarEdicion(){
    this.cancelar.emit();
  }

  public onSubmit(){
    this.alertaSubmitted = true;
    if ( this.formProductoAlerta.valid ){
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_CONFIRMACION' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.guardarAlerta();
        },
        reject: () => {
        }
      } );
    }
  }

  public guardarAlerta(){
    this.procesando = true;
    this.alertaService.obtenerPorId(this.f.idAlerta.value).subscribe( alerta => {
      //SI LA ALERTA ESTA INHABILITADA Y EL PRODUCTO ALERTA HABILITADO NO DEBE DEJAR GUARDAR
      //SI LA ALERTA ESTA INHABILITADA Y EL PRODUCTO ALERTA INHABILITADO DEBE DEJAR GUARDAR
      if ( alerta && !alerta.indicadorHabilitado ) {
        if ( this.f.indicadorHabilitado.value ){
          this.procesando = false;
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAINHABILITADA' )
            } );
          //this.f.indicadorHabilitado.setValue( false );
        } else {
          this.saveProductoAlerta();
        }
      } else {
        this.saveProductoAlerta();
      }

      /*if ( alerta && alerta.indicadorHabilitado ){
        this.productoAlerta = {
          idAlerta: this.f.idAlerta.value,
          idProducto: this.producto.idProducto,
          indicadorHabilitado: !this.f.indicadorHabilitado.value ? false : this.f.indicadorHabilitado.value,
          indicadorNoAplica: !this.f.noAplica.value ? false : this.f.noAplica.value,
          auditoriaFecha: null,
          auditoriaUsuario: null,
          idProductoAlerta: this.idProductoAlerta ? this.idProductoAlerta : null
        } as ProductoAlerta;

        if ( !this.idProductoAlerta ) {
          this.productoAlertaService.crear(this.productoAlerta).subscribe( prodAlerta => {
            this.idProductoAlerta = prodAlerta.idProductoAlerta;
            this.loadAlerta();
            this.setTituloBoton();
            this.alertaSubmitted = false;
            this.procesando = false;
            this.actualizarProductoAlerta.emit(prodAlerta);
            this.navService.setMesage( 0,
              {
                severity: 'success',
                summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAGUARDADA')
              } );
          });
        } else {
          this.productoAlertaService.actualizar(this.productoAlerta).subscribe( prodAlerta => {
            this.idProductoAlerta = prodAlerta.idProductoAlerta;
            this.loadAlerta();
            this.setTituloBoton();
            this.alertaSubmitted = false;
            this.procesando = false;
            this.actualizarProductoAlerta.emit(prodAlerta);
            this.navService.setMesage( 0,
              {
                severity: 'success',
                summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAACTUALIZADA')
              } );
          });
        }
      } else {
        this.procesando = false;
        this.navService.setMesage( 0,
          {
            severity: 'info',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAINHABILITADA' )
          } );
      }*/
    });
  }

  private saveProductoAlerta(){
    this.productoAlerta = {
      id: this.productoAlerta.id,
      idAlerta: this.f.idAlerta.value,
      idProducto: this.producto.idProducto,
      indicadorHabilitado: !this.f.indicadorHabilitado.value ? false : this.f.indicadorHabilitado.value,
      indicadorNoAplica: !this.f.noAplica.value ? false : this.f.noAplica.value,
      auditoriaFecha: null,
      auditoriaUsuario: null,
      idProductoAlerta: this.idProductoAlerta ? this.idProductoAlerta : null
    } as ProductoAlerta;

    if ( !this.idProductoAlerta ) {
      this.productoAlertaService.crear(this.productoAlerta).subscribe( prodAlerta => {
        this.idProductoAlerta = prodAlerta.idProductoAlerta;
        this.loadAlerta();
        this.setTituloBoton();
        this.alertaSubmitted = false;
        this.procesando = false;
        this.actualizarProductoAlerta.emit(prodAlerta);
        this.navService.setMesage( 0,
          {
            severity: 'success',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAGUARDADA')
          } );
      });
    } else {
      this.productoAlertaService.actualizar(this.productoAlerta).subscribe( prodAlerta => {
        this.idProductoAlerta = prodAlerta.idProductoAlerta;
        this.loadAlerta();
        this.setTituloBoton();
        this.alertaSubmitted = false;
        this.procesando = false;
        this.actualizarProductoAlerta.emit(prodAlerta);
        this.navService.setMesage( 0,
          {
            severity: 'success',
            summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ALERTAACTUALIZADA')
          } );
      });
    }
  }
}
